/**
 * API for explicitly signalling an event to the mobile app APIs and
 * to listen for commands from the mobile app.
 */
import {sendSignal} from "@repo/integrations";

function sendConsoleToMobile(
    type: "log" | "error",
    message: string,
    ...optionalParams: any[]
) {
    sendSignal({
        type: "dev:console",
        data: {
            type,
            message,
            optionalParams: optionalParams.map((param) =>
                JSON.stringify(param),
            ),
        },
    });
}

/**
 * Send a console log to the mobile app.
 *
 * @param message The message to log.
 * @param optionalParams Any optional parameters to log.
 */
export function log(message: string, ...optionalParams: any[]): void {
    sendConsoleToMobile("log", message, ...optionalParams);
}

/**
 * Send a console error to the mobile app.
 *
 * @param message The message to log.
 * @param optionalParams Any optional parameters to log.
 */
export function error(message: string, ...optionalParams: any[]) {
    sendConsoleToMobile("error", message, ...optionalParams);
}
